import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  CARD_HEADER: `${cleanedFilename(__filename)}-card-header`,
  NO_FLOWS_CTA: `${cleanedFilename(__filename)}-no-flows`,
  CHART: `${cleanedFilename(__filename)}-chart`,
};
